module.exports = __webpack_public_path__ + "components/GamePrintableFeatured/Worksheet_Thumbnail.png";